import { render, staticRenderFns } from "./inspeTrack.vue?vue&type=template&id=2c70e67b&scoped=true"
import script from "./inspeTrack.vue?vue&type=script&lang=js"
export * from "./inspeTrack.vue?vue&type=script&lang=js"
import style0 from "./inspeTrack.vue?vue&type=style&index=0&id=2c70e67b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70e67b",
  null
  
)

export default component.exports